import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const DELETE_DIARY_ENTRY_MUTATION = gql`
  mutation DeleteDiaryEntry($id: ID!) {
    deleteDiaryEntry(id: $id) {
      success
    }
  }
`;

export function useDeleteDiaryEntry() {
  const [mutation, { loading, error }] = useMutation(DELETE_DIARY_ENTRY_MUTATION);

  const deleteDiaryEntry = async (id: string) => {
    const { data } = await mutation({ variables: { id } });
    return (data as any)?.deleteDiaryEntry?.success === true;
  };

  return { deleteDiaryEntry, loading, error };
}
